export default __webpack_public_path__ + "static/ripple-af221e05f358e8586f1ea208d1cfa45c.svg";